<template>
  <a
    :ref="linkElement"
    :href="url"
    class="govuk-link fds-sortable-table__link"
    @focus="scrollLinkIntoView"
  >
    {{ label }}
    <span
      v-if="screenReaderText"
      class="govuk-visually-hidden"
    >
      {{ screenReaderText }}
    </span>
  </a>
</template>

<script setup>

import { ref } from "vue";

defineProps({
  label: { type: String, required: true },
  screenReaderText: { type: String, required: false },
  url: { type: String, required: true },
});

const linkElement = ref(null);
const scrollLinkIntoView = () => linkElement.value.scrollIntoView();
</script>